import { render, staticRenderFns } from "./iphoneMobile.vue?vue&type=template&id=52171992&"
import script from "./iphoneMobile.vue?vue&type=script&lang=js&"
export * from "./iphoneMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports